import React, { Component } from 'react';
import './PrioritizeCreateModal.scss';
import { Factor } from 'src/components/Factor'
import { Modal } from 'src/components/shared'
import { LABELS, EXAMPLE_FACTORS } from 'src/util/PrioritizeUtil'


export default class PrioritizeCreateModal extends Component {

    render() {
    const { isOpen } = this.props
    return (
      <Modal isOpen={isOpen}>
          <div >
            <div className="modal__header">
              <h1>{LABELS.create_examples}</h1>
              <h4>{LABELS.create_step2_hint}</h4>
            </div>
            <div className="modal__factors">
            {EXAMPLE_FACTORS.map((factor, idx) => <Factor readOnly key={idx} factor={factor} />)}
            </div>
          </div>
      </Modal>
    );
  }
};

